import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import AddContentObjectContainer from './AddContentObjectContainer';

const AddContentObject = ({ duplicate = false, mode = '', testId = '' }) => {
  const { contentTypeName, id } = useParams();
  return (
    <AddContentObjectContainer
      contentTypeName={contentTypeName}
      id={id}
      duplicate={duplicate}
      mode={mode}
      testId={testId}
    />
  );
};

export default AddContentObject;

AddContentObject.propTypes = {
  /**
   * If object is duplicating
   */
  duplicate: PropTypes.bool,
  /**
   * Test id for page
   */
  testId: PropTypes.string,
  /**
   * Content Object mode
   */
  mode: PropTypes.string,
};
